const userCountry = window.shopifyCountry || "GB";

document.addEventListener("DOMContentLoaded", function () {
  // userCountry is already defined at the top of the script
  //console.log('Detected country:', userCountry); // Debugging log

  // Mapping country codes to the corresponding delivery sections
  const countryDeliveryMap = {
    GB: "#uk-delivery", // United Kingdom
    US: "#us-delivery", // USA
    CA: "#ca-delivery", // Canada
    // Note: EU countries will be handled separately
  };

  // List of EU country codes
  const euCountryCodes = [
    "AT",
    "BE",
    "BG",
    "HR",
    "CY",
    "CZ",
    "DK",
    "EE",
    "FI",
    "FR",
    "DE",
    "GR",
    "HU",
    "IE",
    "IT",
    "LV",
    "LT",
    "LU",
    "MT",
    "NL",
    "PL",
    "PT",
    "RO",
    "SK",
    "SI",
    "ES",
    "SE",
  ];

  // Determine the relevant delivery section
  let relevantSection;
  if (countryDeliveryMap[userCountry]) {
    relevantSection = countryDeliveryMap[userCountry];
  } else if (euCountryCodes.includes(userCountry)) {
    relevantSection = "#eu-delivery";
  } else {
    relevantSection = "#row-delivery"; // Default to Rest of World
  }

  // Hide all delivery sections initially
  document.querySelectorAll(".delivery-info").forEach(function (section) {
    section.style.display = "none";
  });

  // Show the relevant delivery section based on user's country
  const sectionElement = document.querySelector(relevantSection);

  // Check if the relevant section exists, then display it
  if (sectionElement) {
    sectionElement.style.display = "block";
  } else {
    console.error(
      "Relevant delivery section not found for country:",
      userCountry
    );
  }

  // Function to hide elements starting from a specific heading within a container
  function hideFromHeading(headingText, container) {
    // Select all h2 elements within the container
    const headings = container.querySelectorAll("h2");
    let startH2 = null;

    // Find the h2 element that matches the headingText (case-insensitive)
    headings.forEach(function (h2) {
      if (h2.textContent.trim().toLowerCase() === headingText.toLowerCase()) {
        startH2 = h2;
      }
    });

    // If the heading is found, hide it and all subsequent sibling elements
    if (startH2) {
      //console.log('Found heading:', startH2.textContent.trim());
      let next = startH2.nextElementSibling;
      // Hide the h2 itself
      startH2.style.display = "none";
      while (next) {
        next.style.display = "none";
        next = next.nextElementSibling;
      }
    } else {
      console.warn("Heading not found:", headingText);
    }
  }

  // Initial hiding for the active tab
  const activeTabContent = document.querySelector(".tab-content.active");
  if (activeTabContent) {
    hideFromHeading("Customs & Import Tax", activeTabContent);
  }

  // Tab navigation handling
  var tabButtons = document.querySelectorAll(".tab-navigation__button");
  var tabContents = document.querySelectorAll(".tab-content");

  tabButtons.forEach(function (button) {
    button.addEventListener("click", function () {
      var target = this.getAttribute("data-tab-target");

      // Remove active classes
      tabButtons.forEach(function (btn) {
        btn.classList.remove("active");
      });
      tabContents.forEach(function (content) {
        content.classList.remove("active");
      });

      // Add active classes to the selected tab
      this.classList.add("active");
      var targetContent = document.getElementById(target);
      targetContent.classList.add("active");

      // Hide "Customs & Import Tax" and everything below in the newly active tab
      hideFromHeading("Customs & Import Tax", targetContent);
    });
  });
});
